<template>
    <div class="grid h-screen grid-rows-[5rem_auto]">
        <header class="px-10 flex items-center justify-between border-b border-grey-300  mobile:px-5">
            <a href="/">
                <img v-if="checkoutStore.brand.toLowerCase() === 'companyweb'" src="/images-new/logo/logo.svg" class="w-36" alt="Companyweb" />
                <img v-else src="/images-new/logo/liza.svg" class="w-36" alt="Liza.nl" />
            </a>
            <checkout-wizard :currentPage="checkoutStore.currentPage"></checkout-wizard>
            <a :href="'/' + checkoutStore.language + '/order'" class="btn btn-text">
                <i class="far fa-times mr-1.5"></i>
                {{translate('annuleren')}}
            </a>
        </header>
        <div class="container grid grid-cols-[auto_25rem] tablet:grid-cols-[auto_19rem] tablet:text-sm mobile:grid-cols-1">
            <main class="my-14">
                <slot name="content"></slot>
            </main>
            <aside class="p-6 mobile:p-0 mobile:mb-6">
                <div class="bg-grey-100 rounded-2xl px-4 py-2 tablet:py-0 tablet:px-2 divide-y divide-grey-300 [&>*]:px-4 [&>*]:py-6">
                    <div class="space-y-6">
                        <div class="font-semibold text-lg">{{translate('samenvatting')}}</div>
                        <div>
                            <div class="text-md">{{checkoutStore.orderedPackage.abonnement.abonnement.toTitleCase().replace('-', ' ')}}</div>
                            <div class="font-medium text-grey-800">€ {{checkoutStore.orderedPackage.abonnement.price.formatThousandSeparator()}}</div>
                        </div>

                        <div v-for="c in checkoutStore.chargeableCountries">
                            <div class="text-md">{{c.name}}</div>
                            <div class="font-medium text-grey-800">€ {{checkoutStore.extraCountryPrice}}</div>
                        </div>

                        <div v-for="addon in checkoutStore.chosenAddons">
                            <div class="text-md">{{translate('addon_' + addon.feature + '_title')}}</div>
                            <div class="font-medium text-grey-800">€ {{addon.price.formatThousandSeparator()}}</div>
                        </div>
                    </div>
                    <div class="grid grid-cols-2">
                        <div>{{translate('subtotaal')}}</div>
                        <div class="text-grey-800 text-right">{{checkoutStore.exclPrice.formatPrice()}}</div>
                        
                        <div>{{translate('btw')}} <span class="text-xs text-grey-700" v-if="checkoutStore.isValidNlVat">({{ translate('btw_verlegd') }} - 0%)</span></div>
                        <div class="text-grey-800 text-right">{{checkoutStore.btwPrice.formatPrice()}}</div>
                        
                        <div class="mt-2.5 ">{{translate('totaal')}}</div>
                        <div class="mt-2.5 font-bold text-right">{{checkoutStore.totalPrice.formatPrice()}}</div>
                    </div>
                    <div>
                        <slot name="sidebar">
                            <button class="btn btn-primary w-full" v-if="checkoutStore.canGoToNextPage" @click.prevent="checkoutStore.nextPage()">{{translate('volgende')}}</button>
                            <button class="btn btn-ghost w-full mt-3" v-if="checkoutStore.canGoToPrevPage" @click.prevent="checkoutStore.prevPage()">{{translate('vorige')}}</button>
                        </slot>
                    </div>
                </div>
            </aside>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import CheckoutWizard from "./wizard.vue";
import {useStore} from "../../store";

export default defineComponent({
    name: "layout.vue",
    components: {CheckoutWizard},
    data() {
        return {
            checkoutStore: useStore()
        }
    }
});
</script>